/* CandyNow custom theme, in-card add-to-cart + live quantity stepper, toast, PDP */
(function () {
  'use strict';
  var R = window.cnRoutes || {};
  var CART = R.cart || '/cart';
  var ADD = (R.cartAdd || '/cart/add') + '.js';
  var UPDATE = CART.replace(/\/$/, '') + '/update.js';
  var CARTJS = CART.replace(/\/$/, '') + '.js';
  var DEBOUNCE = 450;

  /* ---------- toast + count ---------- */
  var toast = document.getElementById('cn-toast');
  var toastMsg = toast && toast.querySelector('.toast__msg');
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    if (msg && toastMsg) toastMsg.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2500);
  }
  function setCount(n) { var el = document.getElementById('cart-count'); if (el) el.textContent = n; }
  function getCart() { return fetch(CARTJS, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function qtyIn(cart, vid) { var q = 0; ((cart && cart.items) || []).forEach(function (it) { if (String(it.variant_id) === String(vid)) q = it.quantity; }); return q; }
  function sel(vid) { return '[data-variant-id="' + String(vid).replace(/"/g, '\\"') + '"]'; }
  // search: relevance order with sold-out included ('show'), or 'hide' when the shopper ticked "Hide out of stock"
  // (same remembered choice as collections). Shopify's default 'last' sank an exact, sold-out match below every loose one.
  var SEARCH_OOS = 'options[unavailable_products]';
  function searchStock() { try { return localStorage.getItem('cn-hide-oos') === '1' ? 'hide' : 'show'; } catch (e) { return 'show'; } }
  function searchUrl(q, extra) { return '/search?q=' + encodeURIComponent(q) + '&type=product&options[unavailable_products]=' + searchStock() + (extra || ''); }
  function escHtml(v) { return String(v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- typo help ("sperree" → spree). Shopify's search forgives about one typo. When a search finds few or
     no results, each unknown word is matched against the catalogue's own words (assets/cn-search-words.json, built by
     scripts/search-words.mjs): 1 letter off for 4–5 letter words, 2 for longer words, shorter words never; a word that
     starts a real word ("skit") is left alone; ties go to the same first letter, then the word more products use.
     Real matches always come first; the close-spelling ones follow. ---------- */
  var cnWords = null;
  function searchWords() { if (!cnWords) cnWords = fetch(window.cnWordsUrl || '').then(function (r) { return r.json(); }).catch(function () { return {}; }); return cnWords; }
  function normWord(w) { return String(w || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function osaDist(a, b, max) {   // edit distance counting a swap of two letters as one, giving up past max
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev2 = null, prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i]; var rowMin = i;
      for (j = 1; j <= b.length; j++) {
        var v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, prev2[j - 2] + 1);
        cur[j] = v; if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
      prev2 = prev; prev = cur;
    }
    return prev[b.length];
  }
  function fixWord(w, dict, keys) {
    w = normWord(w);
    if (w.length < 4 || /\d/.test(w) || dict[w]) return w;
    for (var i = 0; i < keys.length; i++) if (keys[i].length > w.length && keys[i].indexOf(w) === 0) return w;   // still typing it
    var max = w.length >= 6 ? 2 : 1, best = '', bd = max + 1, bs = -1;
    for (i = 0; i < keys.length; i++) {
      var k = keys[i]; if (Math.abs(k.length - w.length) > max) continue;
      var d = osaDist(w, k, max); if (d > max) continue;
      var sc = (k[0] === w[0] ? 1e6 : 0) + dict[k];
      if (d < bd || (d === bd && sc > bs)) { best = k; bd = d; bs = sc; }
    }
    return best || w;
  }
  // resolves to the corrected query, or '' when nothing needs correcting
  function fixQuery(q) {
    return searchWords().then(function (dict) {
      var keys = Object.keys(dict || {}), changed = false;
      if (!keys.length) return '';
      var out = String(q).trim().split(/\s+/).map(function (w) { var f = fixWord(w, dict, keys); if (f && f !== normWord(w)) { changed = true; return f; } return w; });
      return changed ? out.join(' ') : '';
    });
  }

  /* ---------- card control build / swap ---------- */
  function buildQtyEl(vid, qty, max) {
    var d = document.createElement('div');
    d.className = 'cn-qty';
    d.dataset.variantId = vid;
    if (max) d.dataset.max = max;
    d.dataset.qty = qty;
    d.innerHTML =
      '<button type="button" class="cn-qty-btn" data-action="minus" aria-label="Decrease quantity">−</button>' +
      '<input type="text" inputmode="numeric" class="cn-qty-count" data-cn-qty-count value="' + qty + '" aria-label="Quantity">' +
      '<button type="button" class="cn-qty-btn" data-action="plus" aria-label="Increase quantity">+</button>';
    return d;
  }
  function buildFormEl(vid, max) {
    var f = document.createElement('form');
    f.className = 'cn-cartform';
    f.method = 'post';
    f.action = R.cartAdd || '/cart/add';
    f.dataset.variantId = vid;
    if (max) f.dataset.stockMax = max;
    f.innerHTML = '<input type="hidden" name="id" value="' + vid + '"><button type="submit" class="qadd">Add to cart</button>';
    return f;
  }
  function setQtyDisplay(el, qty) { el.dataset.qty = qty; var c = el.querySelector('[data-cn-qty-count]'); if (c) { if (c.tagName === 'INPUT') c.value = qty; else c.textContent = qty; } }
  function swapFormToQty(form, qty) { var el = buildQtyEl(form.dataset.variantId, qty, form.dataset.stockMax); form.replaceWith(el); return el; }
  function swapQtyToForm(qtyEl) { var f = buildFormEl(qtyEl.dataset.variantId, qtyEl.dataset.max); qtyEl.replaceWith(f); return f; }
  function flashMax(el) { el.classList.add('flash-max'); setTimeout(function () { el.classList.remove('flash-max'); }, 600); }
  function markSaving(el) { el.classList.add('cn-qty--saving'); el.classList.remove('cn-qty--saved'); }
  function flashSaved(el) {
    el.classList.remove('cn-qty--saving');
    el.classList.add('cn-qty--saved');
    clearTimeout(el._savedT);
    el._savedT = setTimeout(function () { el.classList.remove('cn-qty--saved'); }, 1200);
  }
  function isEditing(el) { return !!el._cnTimer; }

  /* ── Notify-me modal (posts a Shopify contact form to the store owner) ── */
  function openNotify(btn) {
    var m = document.getElementById('cn-notify');
    if (!m) { showToast('Notifications are coming soon'); return; }
    var kind = btn.getAttribute('data-cn-notify-kind') || 'restock';
    var name = btn.getAttribute('data-cn-notify-name') || '';
    var date = btn.getAttribute('data-cn-notify-date') || '';
    m._kind = kind; m._name = name; m._date = date; m._vid = btn.getAttribute('data-variant-id') || '';
    var title = m.querySelector('[data-cn-notify-title]');
    var sub = m.querySelector('[data-cn-notify-sub]');
    if (kind === 'preorder') {
      title.textContent = 'Notify me when it opens';
      sub.textContent = name ? (name + (date ? ', opens ' + date : '') + '. We’ll email you when pre-orders open.') : 'We’ll email you when pre-orders open.';
    } else {
      title.textContent = 'Notify me when it’s back';
      sub.textContent = name ? ('We’ll email you when “' + name + '” is back in stock.') : 'We’ll email you when this is back in stock.';
    }
    m.querySelector('[data-cn-notify-form]').hidden = false;
    m.querySelector('[data-cn-notify-ok]').hidden = true;
    m.querySelector('[data-cn-notify-err]').hidden = true;
    m.hidden = false; document.body.style.overflow = 'hidden';
    var cem = m.getAttribute('data-cn-customer-email') || '';
    var lbl = m.querySelector('.cn-notify__lbl');
    if (lbl) lbl.textContent = cem ? 'Your email (your account)' : 'Your email';
    var inp = m.querySelector('#cn-notify-email');
    if (inp) { inp.value = cem; setTimeout(function () { inp.focus(); }, 30); }
  }
  function closeNotify() { var m = document.getElementById('cn-notify'); if (m) { m.hidden = true; document.body.style.overflow = ''; } }
  (function initNotify() {
    var m = document.getElementById('cn-notify');
    if (!m) return;
    m.addEventListener('click', function (e) { if (e.target.closest('[data-cn-notify-close]')) { e.preventDefault(); closeNotify(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) closeNotify(); });
    var form = m.querySelector('[data-cn-notify-form]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = m.querySelector('#cn-notify-email');
      var email = (inp && inp.value || '').trim();
      if (!email || email.indexOf('@') < 1) { if (inp) inp.focus(); return; }
      var btn = m.querySelector('[data-cn-notify-submit]');
      btn.disabled = true; btn.textContent = 'Sending…';
      var kind = m._kind, name = m._name, date = m._date, vid = m._vid;
      var done = function (already) {
        m.querySelector('[data-cn-notify-form]').hidden = true;
        var ok = m.querySelector('[data-cn-notify-ok]'); ok.hidden = false;
        m.querySelector('[data-cn-notify-okmsg]').textContent = already
          ? (email + ' is already on the list for ' + (name || 'this item') + '. We’ll email you the moment it’s back.')
          : (kind === 'preorder' ? ('We’ll email ' + email + ' when ' + (name || 'this window') + ' opens.') : ('We’ll email ' + email + ' when ' + (name || 'this item') + ' is back.'));
        btn.disabled = false; btn.textContent = 'Notify me';
      };
      // Every request goes to the worker (/apps/candynow/notify): back-in-stock ones are stored against the
      // variant and emailed automatically when stock returns; pre-order window ones are stored for staff.
      // No contact-form fallback: Shopify's contact form now demands a captcha token, which a script can't supply.
      var hp = m.querySelector('[data-cn-notify-hp]');
      var payload = kind === 'restock' && vid ? { email: email, variant_id: vid, company: hp ? hp.value : '' }
                                             : { email: email, kind: 'preorder', name: name, date: date, company: hp ? hp.value : '' };
      var errEl = m.querySelector('[data-cn-notify-err]');
      fetch('/apps/candynow/notify', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok && d && d.ok, d: d }; }).catch(function () { return { ok: false, d: null }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.d && res.d.error) || 'Something went wrong, please try again.');
          if (vid) { try { var subs = JSON.parse(localStorage.getItem('cn-notify-subs') || '{}'); subs[vid] = email; localStorage.setItem('cn-notify-subs', JSON.stringify(subs)); } catch (e) {} }
          done(!!res.d.already);
        })
        .catch(function (err) {
          errEl.textContent = (err && err.message && err.message.length < 120) ? err.message : 'Something went wrong, please try again.';
          errEl.hidden = false; btn.disabled = false; btn.textContent = 'Notify me';
        });
    });
  })();

  /* ── First-visit intro video (snippet cn-intro-video). Once per browser, or on demand via
     [data-cn-intro-open] / #tour. Browsers block autoplay with sound for new visitors, so it falls
     back to muted with a "Tap for sound" button, which restarts the film if it is still early. ── */
  (function initIntro() {
    var m = document.getElementById('cn-intro');
    if (!m) return;
    var frame = m.querySelector('.cn-intro__frame');
    var sound = m.querySelector('[data-cn-intro-sound]');
    var v = null;
    function close() {
      if (m.hidden) return;
      m.hidden = true; document.body.style.overflow = '';
      if (v) { v.pause(); v.remove(); v = null; }
    }
    function open() {
      if (!m.hidden) return;
      m.hidden = false; document.body.style.overflow = 'hidden';
      v = m.querySelector('[data-cn-intro-video]').content.querySelector('video').cloneNode(true);
      v.setAttribute('playsinline', ''); v.preload = 'auto';
      frame.insertBefore(v, sound);
      sound.hidden = true;
      v.addEventListener('ended', function () { setTimeout(close, 700); });
      v.addEventListener('volumechange', function () { if (!v.muted) sound.hidden = true; });
      var p = v.play();
      if (p && p.catch) p.catch(function () { if (!v) return; v.muted = true; sound.hidden = false; v.play().catch(function () {}); });
    }
    sound.addEventListener('click', function () {
      if (!v) return;
      if (v.currentTime < 20) v.currentTime = 0;
      v.muted = false; sound.hidden = true; v.play().catch(function () {});
    });
    m.addEventListener('click', function (e) { if (e.target.closest('[data-cn-intro-close]')) { e.preventDefault(); close(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function (e) { if (e.target.closest('[data-cn-intro-open]')) { e.preventDefault(); open(); } });
    if (location.hash === '#tour') { open(); return; }
    var seen = true;
    try { seen = !!localStorage.getItem('cn_intro_seen'); if (!seen) localStorage.setItem('cn_intro_seen', String(Date.now())); } catch (e) {}
    if (!seen) setTimeout(open, 1200);
  })();

  /* keep every card for a variant on the authoritative qty (skip mid-edit + exceptEl) */
  function syncVariant(vid, qty, exceptEl) {
    document.querySelectorAll('.cn-qty' + sel(vid)).forEach(function (q) {
      if (q === exceptEl || isEditing(q)) return;
      if (qty <= 0) swapQtyToForm(q); else setQtyDisplay(q, qty);
    });
    if (qty > 0) {
      document.querySelectorAll('.cn-cartform' + sel(vid)).forEach(function (f) { swapFormToQty(f, qty); });
    }
  }

  /* ---------- ADD (card + PDP) ---------- */
  document.addEventListener('submit', function (e) {
    var card = e.target.closest('.cn-cartform');
    if (card) {
      e.preventDefault();
      var vid = card.dataset.variantId;
      var btn = card.querySelector('button');
      if (btn) btn.disabled = true;
      var addBody = { id: vid, quantity: 1 };
      if (card.dataset.poProp) addBody.properties = { 'Pre-order': card.dataset.poProp };
      else if (card.dataset.season) addBody.properties = { 'Pre-order': card.dataset.season };
      fetch(ADD, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(addBody) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { if (btn) btn.disabled = false; showToast((res.d && res.d.description) || 'Could not add to cart'); return; }
          showToast('Item added to your cart');
          return getCart().then(function (cart) {
            setCount(cart.item_count);
            var q = qtyIn(cart, vid) || 1;
            if (card.isConnected) { var el = swapFormToQty(card, q); syncVariant(vid, q, el); }
            else syncVariant(vid, q, null);
          });
        })
        .catch(function () { if (btn) btn.disabled = false; showToast('Could not add to cart'); });
      return;
    }
    var pdp = e.target.closest('[data-cn-productform]');
    if (pdp) {
      e.preventDefault();
      var b = pdp.querySelector('[type="submit"]');
      var lbl = b ? b.textContent : '';
      if (b) b.disabled = true;
      var o = {};
      new FormData(pdp).forEach(function (v, k) { o[k] = v; });
      if (o.quantity) o.quantity = parseInt(o.quantity, 10) || 1;
      fetch(ADD, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(o) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (b) { b.disabled = false; b.textContent = lbl; }
          if (!res.ok) { showToast((res.d && res.d.description) || 'Could not add to cart'); return; }
          showToast('Item added to your cart');
          return getCart().then(function (c) { setCount(c.item_count); });
        })
        .catch(function () { if (b) { b.disabled = false; b.textContent = lbl; } showToast('Could not add to cart'); });
    }
  });

  /* ---------- stepper +/- and notify ---------- */
  // home hero slider (sections/home.liquid): auto-advance, pause on hover/focus, dots, theme-editor block select
  (function () {
    var root = document.querySelector('[data-cn-hero]');
    if (!root) return;
    var slides = root.querySelectorAll('[data-cn-slide]'), dots = root.querySelectorAll('[data-cn-dot]');
    if (slides.length < 2) return;
    var cur = 0, timer = null, paused = false, every = Math.max(3, parseInt(root.getAttribute('data-interval') || '6', 10)) * 1000;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === cur; s.classList.toggle('is-on', on); s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('a,button').forEach(function (el) { if (on) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1'); });
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === cur); d.setAttribute('aria-selected', k === cur ? 'true' : 'false'); });
    }
    function start() { clearInterval(timer); if (!still) timer = setInterval(function () { if (!paused && !document.hidden) show(cur + 1); }, every); }
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-cn-dot'), 10)); start(); }); });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    document.addEventListener('shopify:block:select', function (e) {   // theme editor: show the slide being edited
      slides.forEach(function (s, k) { if (s.getAttribute('data-block-id') === (e.detail && e.detail.blockId)) { show(k); paused = true; } });
    });
    document.addEventListener('shopify:block:deselect', function () { paused = false; });
    show(0); start();
  })();

  // seasonal page: /collections/seasonal#christmas (or #halloween, #easter, #valentine) opens that season's tab
  (function () {
    var want = { christmas: 'xmas', xmas: 'xmas', halloween: 'halloween', easter: 'easter', valentine: 'valentine', valentines: 'valentine' }[String(location.hash).slice(1).toLowerCase()];
    var tab = want && document.querySelector('[data-season-tab="' + want + '"]');
    if (!tab) return;   // that season has nothing in stock: the page keeps its first season
    document.querySelectorAll('[data-season-tab]').forEach(function (t) { t.classList.toggle('is-on', t === tab); });
    document.querySelectorAll('[data-season-group]').forEach(function (g) { g.classList.toggle('is-hidden', g.dataset.seasonGroup !== want); });
  })();

  document.addEventListener('click', function (e) {
    var acc = e.target.closest('[data-cn-acc]');
    if (acc) { acc.setAttribute('aria-expanded', acc.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'); return; }

    var st = e.target.closest('[data-season-tab]');
    if (st) {
      var key = st.dataset.seasonTab;
      document.querySelectorAll('[data-season-tab]').forEach(function (t) { t.classList.toggle('is-on', t === st); });
      document.querySelectorAll('[data-season-group]').forEach(function (g) { g.classList.toggle('is-hidden', g.dataset.seasonGroup !== key); });
      return;
    }

    var nb = e.target.closest('[data-cn-notify]');
    if (nb) { e.preventDefault(); openNotify(nb); return; }

    var b = e.target.closest('.cn-qty-btn');
    if (!b) return;
    var el = b.closest('.cn-qty');
    if (!el) return;
    var max = parseInt(el.dataset.max || '9999', 10);
    var cur = parseInt(el.dataset.qty || '0', 10) || 0;
    var next = b.dataset.action === 'plus' ? cur + 1 : cur - 1;
    if (next > max) { flashMax(el); return; }
    if (next < 0) next = 0;
    setQtyDisplay(el, next);
    markSaving(el);
    el._cnGen = (el._cnGen || 0) + 1;      // bump generation on each interaction
    clearTimeout(el._cnTimer);             // per-ELEMENT debounce (not per-variant)
    el._cnTimer = setTimeout(function () { commit(el); }, DEBOUNCE);
  });

  /* ---------- editable qty: type a number, commits on blur / Enter ---------- */
  document.addEventListener('input', function (e) {
    var inp = e.target.closest('input[data-cn-qty-count]');
    if (!inp) return;
    var el = inp.closest('.cn-qty'); if (!el) return;
    var clean = inp.value.replace(/[^0-9]/g, '');
    if (clean !== inp.value) inp.value = clean;
    markSaving(el);                                        // mark unsaved; commit happens on blur / Enter
    if (clean === '') return;                              // let them clear before retyping
    var max = parseInt(el.dataset.max || '9999', 10);
    var val = parseInt(clean, 10);
    if (val > max) { val = max; inp.value = String(max); flashMax(el); }
    el.dataset.qty = val;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var inp = e.target.closest('input[data-cn-qty-count]');
    if (inp) { e.preventDefault(); inp.blur(); }
  });
  document.addEventListener('focusin', function (e) {
    var inp = e.target.closest('input[data-cn-qty-count]');
    if (inp) inp.select();
  });
  document.addEventListener('focusout', function (e) {
    var inp = e.target.closest('input[data-cn-qty-count]');
    if (!inp) return;
    var el = inp.closest('.cn-qty'); if (!el) return;
    var max = parseInt(el.dataset.max || '9999', 10);
    var val = parseInt(inp.value.replace(/[^0-9]/g, ''), 10);
    if (isNaN(val)) val = parseInt(el.dataset.qty || '0', 10) || 0;   // blank -> revert to last known
    if (val > max) { val = max; flashMax(el); }
    if (val < 0) val = 0;
    setQtyDisplay(el, val);
    if (e.relatedTarget && el.contains(e.relatedTarget)) return;      // moving to a +/- button: it commits
    markSaving(el);
    el._cnGen = (el._cnGen || 0) + 1;
    clearTimeout(el._cnTimer);
    commit(el);
  });

  function commit(el) {
    var vid = el.dataset.variantId;
    var gen = el._cnGen;                    // snapshot; a newer click bumps this
    var qty = parseInt(el.dataset.qty || '0', 10) || 0;
    el._cnTimer = null;
    var u = {}; u[vid] = qty;
    fetch(UPDATE, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: u }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        var found = qtyIn(cart, vid);
        if (el._cnGen !== gen) { syncVariant(vid, found, el); return; } // newer edit queued: don't clobber el
        if (el.isConnected) {
          if (found <= 0) { swapQtyToForm(el); showToast('Removed from cart'); }
          else { setQtyDisplay(el, found); flashSaved(el); showToast(found + ' in your cart'); }
        }
        syncVariant(vid, found, el.isConnected ? el : null);
      })
      .catch(function () {
        if (el._cnGen !== gen) return;     // a newer edit will reconcile
        el.classList.remove('cn-qty--saving');
        getCart().then(function (cart) {
          setCount(cart.item_count);
          var found = qtyIn(cart, vid);
          if (el.isConnected) { if (found <= 0) swapQtyToForm(el); else setQtyDisplay(el, found); }
          syncVariant(vid, found, el.isConnected ? el : null);
        }).catch(function () {});
      });
  }

  /* ---------- card variant picker (multi-variant products): one button per variant ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cn-card-variant]');
    if (!o) return;
    var card = o.closest('.pcard');
    if (!card) return;
    var vid = o.dataset.cnCardVariant;
    var group = o.closest('.cn-vbtns');
    if (group) group.querySelectorAll('.cn-vbtn').forEach(function (b) { var on = b === o; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    if (card.dataset.variantId === vid) return;
    card.dataset.variantId = vid;
    var priceEl = card.querySelector('.pcard__buy .price');
    if (priceEl) {
      priceEl.classList.toggle('price--sale', !!o.dataset.compare);
      priceEl.textContent = o.dataset.price || '';
      if (o.dataset.compare) { var sEl = document.createElement('s'); sEl.textContent = o.dataset.compare; priceEl.appendChild(sEl); }
    }
    var stockEl = card.querySelector('[data-cn-stock]');
    if (stockEl) {
      var raw = o.dataset.left || '', left = parseInt(raw, 10) || 0;
      stockEl.classList.toggle('cn-stock--low', left > 0 && left <= 10);
      stockEl.classList.toggle('cn-stock--out', raw !== '' && left <= 0);
      stockEl.textContent = raw === '' ? '' : left > 10 ? 'In stock' : Math.max(left, 0) + ' left';
    }
    var ctl = card.querySelector('.pcard__buy .cn-cartform, .pcard__buy .cn-qty, .pcard__buy .qadd--notify');
    if (!ctl) return;
    if (o.dataset.available !== 'true') {
      var nb = document.createElement('button');
      nb.type = 'button'; nb.className = 'qadd qadd--notify'; nb.textContent = 'Notify me';
      nb.setAttribute('data-cn-notify', ''); nb.dataset.cnNotifyKind = 'restock'; nb.dataset.variantId = vid;
      var nm = card.querySelector('.pcard__name');
      nb.dataset.cnNotifyName = (nm ? nm.textContent : '') + ' (' + (o.dataset.title || '') + ')';
      ctl.replaceWith(nb);
      return;
    }
    var f = buildFormEl(vid, o.dataset.max);
    ctl.replaceWith(f);
    getCart().then(function (cart) {
      var q = qtyIn(cart, vid);
      if (q > 0 && f.isConnected && f.dataset.variantId === vid) swapFormToQty(f, q);
    }).catch(function () {});
  });

  /* ---------- home product rows: one row, arrows scroll a page at a time ---------- */
  document.querySelectorAll('[data-prow]').forEach(function (row) {
    var track = row.querySelector('[data-prow-track]');
    var head = row.previousElementSibling;
    var prev = head && head.querySelector('[data-prow-prev]'), next = head && head.querySelector('[data-prow-next]');
    if (!track || !prev || !next) return;
    var update = function () {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- hydrate cards from current cart on load ---------- */
  function hydrate() {
    getCart().then(function (cart) {
      setCount(cart.item_count);
      var map = {};
      (cart.items || []).forEach(function (it) { map[it.variant_id] = it.quantity; });
      document.querySelectorAll('.cn-cartform').forEach(function (f) {
        var vid = f.dataset.variantId;
        if (vid && map[vid]) swapFormToQty(f, map[vid]);
      });
    }).catch(function () {});
  }
  if (document.readyState !== 'loading') hydrate();
  else document.addEventListener('DOMContentLoaded', hydrate);

  /* ---------- PDP variant select + gallery ---------- */
  var vsel = document.querySelector('[data-cn-variants]');
  var vdataEl = document.getElementById('cn-variant-data');
  if (vsel && vdataEl) {
    var variants = JSON.parse(vdataEl.textContent);
    vsel.addEventListener('change', function () {
      var v = variants.filter(function (x) { return String(x.id) === String(vsel.value); })[0];
      var priceEl = document.getElementById('cn-pdp-price');
      var btn = document.getElementById('cn-pdp-add');
      var idInput = document.getElementById('cn-pdp-variant-id');
      if (idInput && v) idInput.value = v.id;
      if (priceEl && v) priceEl.innerHTML = v.price_html;
      if (btn) { var ok = v && v.available; btn.disabled = !ok; btn.textContent = ok ? 'Add to cart' : 'Sold out'; }
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cn-thumb]');
    if (!t) return;
    var main = document.getElementById('cn-pdp-main');
    if (main) { main.src = t.getAttribute('data-full'); main.srcset = ''; }
  });

  /* ---------- header predictive search (candyroom-style suggestions) ---------- */
  (function () {
    var wrap = document.querySelector('.hsearch');
    if (!wrap) return;
    var input = wrap.querySelector('input[type="search"]');
    var dd = document.getElementById('cn-search-results');
    if (!input || !dd) return;
    var timer, lastQ = '';

    function close() { dd.classList.remove('open'); }

    function hydrateSuggestions() {
      getCart().then(function (cart) {
        var map = {};
        (cart.items || []).forEach(function (it) { map[it.variant_id] = it.quantity; });
        dd.querySelectorAll('.cn-cartform').forEach(function (f) {
          var vid = f.dataset.variantId;
          if (vid && map[vid]) swapFormToQty(f, map[vid]);
        });
      }).catch(function () {});
    }

    function run(q) {
      if (q.length < 2) { close(); return; }
      // the search page's own first 8 results (templates/search.suggest.liquid), so the drop-down and the page always agree
      fetch('/search?q=' + encodeURIComponent(q) + '&type=product&options[unavailable_products]=' + searchStock() + '&view=suggest', { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (input.value.trim() !== q) return; // a newer keystroke won
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var res = doc.getElementById('cn-ps-results');
          dd.innerHTML = (res && res.children.length) ? res.innerHTML : '<div class="cn-sresult__hint">No products match your search.</div>';
          var all = dd.querySelector('[data-cn-search-all]');   // "See all N results" keeps the shopper's sold-out choice
          if (all) { var au = new URL(all.href, location.href); au.searchParams.set(SEARCH_OOS, searchStock()); all.href = au.toString(); }
          dd.classList.add('open');
          hydrateSuggestions();
          var rows = dd.querySelectorAll('.cn-sresult').length;
          if (rows < 8) fuzzyMore(q, rows);
        })
        .catch(function () { close(); });
    }
    function fuzzyMore(q, rows) {
      fixQuery(q).then(function (fq) {
        if (!fq || input.value.trim() !== q) return;
        return fetch(searchUrl(fq, '&view=suggest'), { credentials: 'same-origin', headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (html) {
          if (input.value.trim() !== q) return;
          var res = new DOMParser().parseFromString(html, 'text/html').getElementById('cn-ps-results');
          var have = {};
          dd.querySelectorAll('.cn-sresult__link').forEach(function (a) { have[a.getAttribute('href').split('?')[0]] = 1; });
          var extra = res ? Array.prototype.filter.call(res.querySelectorAll('.cn-sresult'), function (r) { var a = r.querySelector('.cn-sresult__link'); return a && !have[a.getAttribute('href').split('?')[0]]; }) : [];
          if (!extra.length) return;
          var href = escHtml(searchUrl(fq, '&fuzzy_from=' + encodeURIComponent(q)));
          var label = '<div class="cn-sresult__fuzzy">' + (rows ? 'Similar: ' : 'Showing results for ') + '<a href="' + href + '">' + escHtml(fq) + '</a></div>';
          if (!rows) dd.innerHTML = label; else dd.insertAdjacentHTML('beforeend', label);
          extra.slice(0, rows ? 8 - rows : 8).forEach(function (e) { dd.appendChild(e); });
          var all = res.querySelector('[data-cn-search-all]');
          if (!rows && all) { all.setAttribute('href', searchUrl(fq, '&fuzzy_from=' + encodeURIComponent(q))); dd.appendChild(all); }
          hydrateSuggestions();
        });
      }).catch(function () {});
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (q === lastQ) return;
      lastQ = q;
      clearTimeout(timer);
      timer = setTimeout(function () { run(q); }, 200);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && dd.children.length) dd.classList.add('open');
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function (e) { if (!e.target.closest('.hsearch')) close(); });
  })();

  /* ---------- search page + every search form/link: carry the sold-out choice ---------- */
  (function () {
    var want = searchStock();
    document.querySelectorAll('form[action$="/search"]').forEach(function (f) {
      var i = f.querySelector('input[name="' + SEARCH_OOS + '"]');
      if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = SEARCH_OOS; f.appendChild(i); }
      i.value = want;
    });
    document.querySelectorAll('a[href*="/search?"]').forEach(function (a) {
      var u = new URL(a.href, location.href);
      u.searchParams.set(SEARCH_OOS, want);
      a.href = u.toString();
    });
    var box = document.querySelector('[data-cn-search-oos]');
    if (!box) return;
    var cur = new URL(location.href);
    if (cur.searchParams.get(SEARCH_OOS) !== want) {   // arrived without (or with another) choice, e.g. a typed URL
      cur.searchParams.set(SEARCH_OOS, want); cur.searchParams.delete('page'); location.replace(cur.toString()); return;
    }
    box.checked = want === 'hide';
    box.addEventListener('change', function () {
      try { localStorage.setItem('cn-hide-oos', box.checked ? '1' : '0'); } catch (e) {}
      var u = new URL(location.href);
      u.searchParams.set(SEARCH_OOS, box.checked ? 'hide' : 'show');
      u.searchParams.delete('page');
      location.href = u.toString();
    });
  })();

  /* ---------- search page typo help (see fixQuery) ---------- */
  (function () {
    var sp = new URLSearchParams(location.search), from = sp.get('fuzzy_from'), exact = sp.get('exact');
    var hook = document.querySelector('[data-cn-fuzzy]');
    if (!hook) return;
    var q = hook.getAttribute('data-q') || '', count = parseInt(hook.getAttribute('data-count') || '0', 10);
    if (from) {   // arrived through a correction: say so, offer the exact words
      var u0 = new URL(location.href); u0.searchParams.set('q', from); u0.searchParams.delete('fuzzy_from'); u0.searchParams.set('exact', '1');
      hook.insertAdjacentHTML('beforebegin', '<p class="cn-fuzzy-note">Showing results for <b>' + escHtml(q) + '</b>. Search instead for <a href="' + escHtml(u0.toString()) + '">' + escHtml(from) + '</a></p>');
      return;
    }
    if (exact || count >= 24) return;
    fixQuery(q).then(function (fq) {
      if (!fq) return;
      if (!count) {   // nothing for the exact words: show the corrected search
        var u = new URL(location.href); u.searchParams.set('q', fq); u.searchParams.set('fuzzy_from', q); u.searchParams.delete('page');
        location.replace(u.toString()); return;
      }
      var grid = document.querySelector('.shell .grid');
      if (!grid) return;
      return fetch(searchUrl(fq), { credentials: 'same-origin', headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), have = {};
        grid.querySelectorAll('.pcard').forEach(function (c) { have[c.getAttribute('data-variant-id')] = 1; });
        var extra = Array.prototype.filter.call(doc.querySelectorAll('.grid .pcard'), function (c) { return !have[c.getAttribute('data-variant-id')]; });
        if (!extra.length) return;
        grid.insertAdjacentHTML('beforeend', '<div class="cn-fuzzy-divider">Similar results for <a href="' + escHtml(searchUrl(fq, '&fuzzy_from=' + encodeURIComponent(q))) + '">' + escHtml(fq) + '</a></div>');
        var added = extra.map(function (c) { var n = document.importNode(c, true); grid.appendChild(n); return n; });
        getCart().then(function (cart) {
          var map = {}; (cart.items || []).forEach(function (it) { map[it.variant_id] = it.quantity; });
          added.forEach(function (n) { n.querySelectorAll('.cn-cartform').forEach(function (f) { var vid = f.dataset.variantId; if (vid && map[vid]) swapFormToQty(f, map[vid]); }); });
        }).catch(function () {});
      });
    }).catch(function () {});
  })();

  /* ---------- collection: grid/list toggle + infinite scroll ---------- */
  (function () {
    var theGrid = document.querySelector('.shell .grid');
    var toggles = document.querySelectorAll('[data-cn-view]');
    if (theGrid && toggles.length) {
      var applyView = function (v) {
        theGrid.classList.toggle('is-list', v === 'list');
        toggles.forEach(function (b) { b.classList.toggle('is-on', b.dataset.cnView === v); });
      };
      var saved = 'grid';
      try { if (localStorage.getItem('cn-view') === 'list') saved = 'list'; } catch (e) {}
      applyView(saved);
      toggles.forEach(function (b) {
        b.addEventListener('click', function () {
          var v = b.dataset.cnView;
          try { localStorage.setItem('cn-view', v); } catch (e) {}
          applyView(v);
        });
      });
    }

    /* out-of-stock: sold-out sinks to the end; "Hide out of stock" filters SERVER-SIDE
       (Shopify's filter.v.availability=1) so every page stays full — remembered per shopper */
    var cgrid = document.querySelector('[data-cn-grid]');
    if (cgrid) {
      var FP = 'filter.v.availability';
      var cur = new URL(location.href);
      var active = cur.searchParams.get(FP) === '1';
      var remembered = false; try { remembered = localStorage.getItem('cn-hide-oos') === '1'; } catch (e) {}
      if (remembered && !active) { cur.searchParams.set(FP, '1'); cur.searchParams.delete('page'); location.replace(cur.toString()); return; }
      // Sold-out cards to the end of the grid: OFF for now (client, 2026-10-09, "creating some problems").
      // Flip to true to restore; the daily script's collection reorder (OOS_LAST_COLLECTIONS) is off too.
      var OOS_LAST = false;
      var reorderOOS = function () {
        if (!OOS_LAST) return;
        var sold = cgrid.querySelectorAll('.pcard--sold-out');
        for (var i = 0; i < sold.length; i++) cgrid.appendChild(sold[i]);
      };
      reorderOOS();
      window.cnReorderOOS = reorderOOS;
      var oosBox = document.querySelector('[data-cn-hide-oos]');
      if (oosBox) oosBox.checked = active;
      cgrid.classList.toggle('cn-hide-oos', active);   // fallback: hide any stragglers if the filter isn't honoured
      if (oosBox) oosBox.addEventListener('change', function () {
        try { localStorage.setItem('cn-hide-oos', oosBox.checked ? '1' : '0'); } catch (e) {}
        var u = new URL(location.href);
        if (oosBox.checked) u.searchParams.set(FP, '1'); else u.searchParams.delete(FP);
        u.searchParams.delete('page');   // filter changed → back to page 1 so you always land on products
        location.href = u.toString();
      });
      if (active) {
        // keep the filter when changing Show / Sort
        document.querySelectorAll('.cn-tools select option[value*="?"]').forEach(function (o) { if (o.value.indexOf(FP) < 0) o.value += '&' + FP + '=1'; });
        document.querySelectorAll('.cn-tools form').forEach(function (f) {
          if (!f.querySelector('input[name="' + FP + '"]')) { var i = document.createElement('input'); i.type = 'hidden'; i.name = FP; i.value = '1'; f.appendChild(i); }
        });
      }
    }

    var inf = document.querySelector('.grid[data-cn-append]');
    if (!inf) return;
    var loading = false, done = false;
    var status = document.querySelector('[data-cn-infinite-status]');
    function loadNext(after) {
      var link = document.querySelector('[data-cn-next]');
      if (!link || loading || done) { if (after) after(); return; }
      loading = true;
      if (status) status.textContent = 'Loading more…';
      fetch(link.href, { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('.grid[data-cn-append]') || doc.querySelector('.grid');
          var added = [];
          if (newGrid) {
            var frag = document.createDocumentFragment();
            newGrid.querySelectorAll('.pcard').forEach(function (c) { var n = c.cloneNode(true); frag.appendChild(n); added.push(n); });
            inf.appendChild(frag);
          }
          var newNext = doc.querySelector('[data-cn-next]');
          if (newNext) { link.href = newNext.href; }
          else { link.remove(); done = true; }
          if (status) status.textContent = done ? 'All products loaded' : '';
          if (added.length) {
            getCart().then(function (cart) {
              var map = {};
              (cart.items || []).forEach(function (it) { map[it.variant_id] = it.quantity; });
              added.forEach(function (n) {
                n.querySelectorAll('.cn-cartform').forEach(function (f) {
                  var vid = f.dataset.variantId;
                  if (vid && map[vid]) swapFormToQty(f, map[vid]);
                });
              });
            }).catch(function () {});
          }
          if (window.cnReorderOOS) window.cnReorderOOS();   // keep sold-out at the end after loading more
          loading = false;
          if (after) after();
        })
        .catch(function () { loading = false; if (status) status.textContent = ''; if (after) after(); });
    }
    var autoLink = document.querySelector('[data-cn-next][data-cn-auto]');
    var sentinel = document.querySelector('[data-cn-sentinel]');
    if (autoLink && sentinel && 'IntersectionObserver' in window) {
      autoLink.style.display = 'none'; // auto mode: keep it only as the href holder
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) loadNext(function () { if (done) io.disconnect(); });
      }, { rootMargin: '700px' });
      io.observe(sentinel);
    } else {
      // manual mode (96): click the visible "Load more" button
      inf.parentNode.addEventListener('click', function (e) {
        var l = e.target.closest('[data-cn-next]');
        if (!l) return;
        e.preventDefault();
        loadNext();
      });
    }
  })();

  /* ---------- mobile drawer (burger menu) ---------- */
  (function () {
    var drawer = document.getElementById('cn-drawer');
    if (!drawer) return;
    var openBtns = document.querySelectorAll('[data-cn-drawer-open]');
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      void drawer.offsetWidth;
      drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var f = drawer.querySelector('.cn-drawer__close');
      if (f) f.focus();
    }
    function close() {
      drawer.classList.remove('open');
      document.body.style.overflow = '';
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () { drawer.hidden = true; }, 260);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cn-drawer-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) close();
    });
  })();

  /* ---------- cart page: AJAX qty stepper (robust) ---------- */
  (function () {
    var cartEl = document.querySelector('.cart');
    if (!cartEl || !cartEl.querySelector('.cart-stepper')) return;
    var CHANGE = CART.replace(/\/$/, '') + '/change.js';
    function money(c) { return '$' + (c / 100).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function reconcile(st, key, input, cart, errDesc) {
      setCount(cart.item_count);
      var sub = document.querySelector('[data-cart-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
      var item = (cart.items || []).filter(function (it) { return it.key === key; })[0];
      if (!item) { // genuinely removed
        var row = st.closest('tr'); var tb = row && row.parentNode;
        if (row) row.remove();
        if (cart.item_count === 0 || (tb && !tb.querySelector('tr'))) location.reload();
        return;
      }
      input.value = item.quantity; // snap to the real (capped) quantity
      var lt = document.querySelector('.cart-line-total[data-line-key="' + key + '"]'); if (lt) lt.textContent = money(item.final_line_price);
      if (errDesc) showToast(errDesc);
    }
    function commit(st) {
      var key = st.dataset.lineKey;
      var input = st.querySelector('.cart-stepper__n');
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      var gen = st._gen;
      st.classList.add('is-busy');
      fetch(CHANGE, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          st.classList.remove('is-busy');
          if (st._gen !== gen) return; // superseded by a newer edit
          if (!res.ok) { // e.g., exceeds stock: DON'T remove — snap back + tell them
            return getCart().then(function (cart) { reconcile(st, key, input, cart, (res.d && res.d.description) || 'That’s more than we have in stock'); });
          }
          reconcile(st, key, input, res.d, null);
        })
        .catch(function () {
          st.classList.remove('is-busy');
          if (st._gen !== gen) return;
          getCart().then(function (cart) { reconcile(st, key, input, cart, null); }).catch(function () {});
        });
    }
    function schedule(st) { st._gen = (st._gen || 0) + 1; clearTimeout(st._t); st._t = setTimeout(function () { commit(st); }, 650); }
    function commitNow(st) { st._gen = (st._gen || 0) + 1; clearTimeout(st._t); commit(st); }
    cartEl.addEventListener('click', function (e) {
      var b = e.target.closest('.cart-stepper__btn');
      if (b) {
        var st = b.closest('.cart-stepper');
        var input = st.querySelector('.cart-stepper__n');
        var nv = (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10);
        if (nv < 1) nv = 1; // '-' stops at 1; use Remove to delete
        input.value = nv;
        schedule(st);
        return;
      }
      var rm = e.target.closest('[data-cart-remove]');
      if (rm) { e.preventDefault(); var st2 = rm.parentNode.querySelector('.cart-stepper'); if (st2) { st2.querySelector('.cart-stepper__n').value = 0; commitNow(st2); } }
    });
    cartEl.addEventListener('input', function (e) { var i = e.target.closest('.cart-stepper__n'); if (i) schedule(i.closest('.cart-stepper')); });
    cartEl.addEventListener('change', function (e) { var i = e.target.closest('.cart-stepper__n'); if (i) { if ((parseInt(i.value, 10) || 0) < 1) i.value = 1; commitNow(i.closest('.cart-stepper')); } });
    cartEl.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.closest('.cart-stepper__n')) { e.preventDefault(); e.target.blur(); } });
  })();

  /* ---------- sticky collapsing header (keeps search in reach) ---------- */
  (function () {
    var hdr = document.querySelector('.site-header');
    if (!hdr) return;
    var ticking = false;
    function upd() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (hdr.classList.contains('is-compact')) { if (y < 20) hdr.classList.remove('is-compact'); }
      else if (y > 70) hdr.classList.add('is-compact');
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  })();

  /* ---------- referral capture (?ref= → cart attribute → lands on the order) ---------- */
  (function () {
    function readCookie(n) { var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)'); return m ? decodeURIComponent(m.pop()) : ''; }
    function writeCookie(n, v, days) { var d = new Date(); d.setTime(d.getTime() + days * 864e5); document.cookie = n + '=' + encodeURIComponent(v) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax'; }
    var p = new URLSearchParams(location.search);
    var ref = (p.get('ref') || p.get('REF') || '').trim().replace(/[^a-zA-Z0-9._-]/g, '').slice(0, 80);
    if (ref) writeCookie('cn_ref', ref, 60);        // last-click wins, remembered 60 days
    else ref = readCookie('cn_ref');
    if (!ref) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.attributes && cart.attributes.Referral === ref) return;   // already tagged
        return fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { Referral: ref } })
        });
      }).catch(function () {});
  })();

  /* ---------- wholesale access: send / re-send an application, stamp new registrations ----------
     POST /apps/candynow/request-access (app proxy → worker). The worker records the date on the customer
     (so the gate can show "applied on…" and enforce the 5-day / 30-day re-send rules), tags them for the
     reviewer email, and keeps the business details in the customer note. */
  (function () {
    var API = '/apps/candynow/request-access';
    function send(payload) {
      return fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { j.httpOk = r.ok; j.status = r.status; return j; }); });
    }
    /* just registered: stamp the application date once (the Flow already emailed the reviewer) */
    try {
      var cnNotifyEl = document.getElementById('cn-notify');   /* carries the signed-in customer's email */
      if (localStorage.getItem('cn_just_registered') && cnNotifyEl && cnNotifyEl.getAttribute('data-cn-customer-email')) {
        localStorage.removeItem('cn_just_registered');
        send({ source: 'registration' }).catch(function () {});
        var g = document.querySelector('[data-cn-gate][data-cn-state="none"]');
        if (g) { var f0 = g.querySelector('.gate__form'), m0 = g.querySelector('[data-cn-gate-msg]'), s0 = g.querySelector('[data-cn-gate-sent]'); if (f0) f0.hidden = true; if (m0) m0.hidden = true; if (s0) s0.hidden = false; }
      }
    } catch (e) {}

    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-cn-gate] .gate__form');
      if (!form) return;
      e.preventDefault();
      var gate = form.closest('[data-cn-gate]'), btn = form.querySelector('button[type="submit"]'), err = form.querySelector('[data-cn-access-error]');
      var val = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? (el.value || '').trim() : ''; };
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
      if (err) err.hidden = true;
      send({ source: 'gate', business: val('contact[Business name]'), phone: val('contact[Phone]'), about: val('contact[body]') })
        .then(function (j) {
          if (j.status === 404) return 'fallback';                       // proxy not reachable → plain contact form
          if (!j.ok) throw new Error(j.error || 'We could not send your request, please try again.');
          // the worker emails the store inbox with Approve / More info / Reject buttons; plain contact-form copy only if it could not
          if (!j.reviewer_emailed) { try { navigator.sendBeacon(form.getAttribute('action') || '/contact', new FormData(form)); } catch (e2) {} }
          return 'sent';
        })
        .then(function (res) {
          if (res === 'fallback') { form.submit(); return; }
          var msg = gate.querySelector('[data-cn-gate-msg]'), sent = gate.querySelector('[data-cn-gate-sent]');
          form.hidden = true; if (msg) msg.hidden = true; if (sent) sent.hidden = false;
        })
        .catch(function (ex) {
          if (btn) { btn.disabled = false; btn.textContent = label; }
          if (err) { err.textContent = ex.message; err.hidden = false; }
        });
    });
  })();

  /* ---------- sidebar promo: the Deals section renders the box in the layout, move it under the menu ---------- */
  (function () {
    function placePromo() {
      var box = document.querySelector('[data-cn-side-promo]'), slot = document.querySelector('[data-cn-side-promo-slot]');
      if (!box || !slot) return;
      slot.replaceWith(box); box.hidden = false;
    }
    placePromo();
    document.addEventListener('shopify:section:load', function () { setTimeout(placePromo, 0); });
  })();

  /* ---------- split checkout: in-stock vs pre-orders as two separate orders ---------- */
  (function () {
    function isPre(it) { return !!(it.properties && it.properties['Pre-order']); }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cn-checkout]');
      if (!b) return;
      e.preventDefault();
      var mode = b.getAttribute('data-cn-checkout');   // 'available' | 'preorder'
      b.disabled = true;
      var label = b.textContent;
      /* legacy path: set the other group aside and go to Shopify checkout (used for in-stock items,
         and as a fallback for pre-orders if the reservation service isn't reachable) */
      function splitCheckout(cart) {
        var remove = (cart.items || []).filter(function (it) { return mode === 'available' ? isPre(it) : !isPre(it); });
        if (!remove.length) { window.location = '/checkout'; return; }
        try { localStorage.setItem('cn_stash', JSON.stringify(remove.map(function (it) { return { id: it.variant_id, quantity: it.quantity, properties: it.properties }; }))); } catch (e) {}
        var updates = {}; remove.forEach(function (it) { updates[it.key] = 0; });
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
          .then(function () { window.location = '/checkout'; });
      }
      /* pre-orders: reserve as a DRAFT ORDER through the app proxy (nothing billed, no checkout) */
      function reservePreorders(cart) {
        var pre = (cart.items || []).filter(isPre);
        if (!pre.length) { window.location = '/checkout'; return; }
        b.textContent = 'Reserving…';
        return fetch('/apps/candynow/preorder', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: pre.map(function (it) { return { id: it.variant_id, quantity: it.quantity, properties: it.properties }; }),
            attributes: cart.attributes || {}
          })
        }).then(function (r) {
          if (r.status === 404) { var e = new Error('fallback'); e.fallback = true; throw e; }
          return r.json().then(function (j) { if (!r.ok || !j.ok) throw new Error(j.error || 'We could not reserve your pre-order, please try again.'); return j; });
        }).then(function (j) {
          var updates = {}; pre.forEach(function (it) { updates[it.key] = 0; });
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
            .then(function () { try { sessionStorage.setItem('cn_reserved', JSON.stringify(j)); } catch (e) {} window.location = '/cart'; });
        }).catch(function (err) {
          if (err && err.fallback) return splitCheckout(cart);   // proxy not configured yet → old two-order flow
          b.disabled = false; b.textContent = label;
          showToast((err && err.message) || 'We could not reserve your pre-order, please try again.');
        });
      }
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { return mode === 'preorder' ? reservePreorders(cart) : splitCheckout(cart); })
        .catch(function () { b.disabled = false; b.textContent = label; window.location = '/checkout'; });
    });
    /* cart page: show the reservation confirmation left by reservePreorders() */
    (function () {
      var panel = document.querySelector('[data-cn-reserved]'); if (!panel) return;
      var j; try { j = JSON.parse(sessionStorage.getItem('cn_reserved') || 'null'); sessionStorage.removeItem('cn_reserved'); } catch (e) {}
      if (!j || !j.ok) return;
      var n = panel.querySelector('[data-cn-reserved-name]'); if (n) n.textContent = j.name || '';
      var it = panel.querySelector('[data-cn-reserved-items]'); if (it) it.textContent = j.count + (j.count === 1 ? ' product' : ' products');
      var t = panel.querySelector('[data-cn-reserved-total]'); if (t) t.textContent = (j.currency ? '$' : '') + Number(j.total || 0).toFixed(2) + (j.currency ? ' ' + j.currency : '');
      panel.hidden = false; panel.classList.add('is-on');
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
    })();
    /* after landing back on the cart from a split checkout, nudge to finish the other group */
    try { if (sessionStorage.getItem('cn_pre_restored')) { sessionStorage.removeItem('cn_pre_restored'); setTimeout(function () { showToast('Your other items are back in the cart, check them out below'); }, 400); } } catch (e) {}

    /* when the shopper returns to the store, restore the group that was set aside + take them to the cart */
    (function () {
      var stash; try { stash = JSON.parse(localStorage.getItem('cn_stash') || 'null'); } catch (e) {}
      if (!stash || !stash.length) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var have = {}; (cart.items || []).forEach(function (it) { have[it.variant_id] = true; });
          var add = stash.filter(function (s) { return !have[s.id]; }).map(function (s) { return { id: s.id, quantity: s.quantity, properties: s.properties }; });
          if (!add.length) { try { localStorage.removeItem('cn_stash'); } catch (e) {} return; }
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: add }) })
            .then(function () {
              try { localStorage.removeItem('cn_stash'); sessionStorage.setItem('cn_pre_restored', '1'); } catch (e) {}
              window.location = '/cart';   // land on the cart with the set-aside items ready to check out
            });
        }).catch(function () {});
    })();
  })();
})();

/* ---------- Wordmark: "candynow.ca" in running text is styled like the logo ----------
   candy = bold navy, now = bold red, .ca = bold navy. Colours adapt to the background the word sits on
   (white + coral on navy, all white on red) so it never disappears. Works on editor text, pages and legal copy. */
(function () {
  'use strict';
  var RE = /(^|[^\w\/-])(candy)(now)(\.ca)(?![\w\/])/gi;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1, TITLE: 1, OPTION: 1, SELECT: 1, INPUT: 1, CODE: 1, PRE: 1 };

  function rgb(str) {
    var m = /rgba?\(\s*(\d+)[ ,]+(\d+)[ ,]+(\d+)(?:[ ,\/]+([\d.]+))?/.exec(str || '');
    return m ? { r: +m[1], g: +m[2], b: +m[3], a: m[4] === undefined ? 1 : +m[4] } : null;
  }
  function tone(el) {
    for (var n = el; n && n.nodeType === 1; n = n.parentNode) {
      var cs = getComputedStyle(n), c = rgb(cs.backgroundColor);
      if (!(c && c.a > 0.5) && cs.backgroundImage && cs.backgroundImage.indexOf('gradient') !== -1) c = rgb(cs.backgroundImage);
      if (c && c.a > 0.5) {
        if (c.r > 170 && c.g < 110 && c.b < 110) return 'red';
        return (0.2126 * c.r + 0.7152 * c.g + 0.0722 * c.b) < 120 ? 'dark' : '';
      }
    }
    return '';
  }
  function skip(node) {
    for (var p = node.parentNode; p && p.nodeType === 1; p = p.parentNode) {
      if (SKIP[p.nodeName]) return true;
      if (p.classList && (p.classList.contains('cn-brand') || p.classList.contains('logo'))) return true;
      if (p.hasAttribute && p.hasAttribute('data-no-brand')) return true;
      if (p.isContentEditable) return true;
    }
    return false;
  }
  function mk(c, n, d, t) {
    var s = document.createElement('span');
    s.className = 'cn-brand' + (t ? ' cn-brand--' + t : '');
    [['c', c], ['n', n], ['d', d]].forEach(function (p) {
      var i = document.createElement('span'); i.className = 'cn-brand__' + p[0]; i.textContent = p[1]; s.appendChild(i);
    });
    return s;
  }
  /* page bodies written in the Shopify editor have the name split by markup: candy<em><strong>now</strong></em>.ca */
  function firstText(el) { var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n; while ((n = w.nextNode())) if (n.nodeValue) return n; return null; }
  function fixSplit(root) {
    var list = root.querySelectorAll ? root.querySelectorAll('em,strong,i,b,span') : [];
    Array.prototype.forEach.call(list, function (el) {
      if (!el.isConnected || (el.textContent || '').trim().toLowerCase() !== 'now' || el.closest('.cn-brand,.logo,[data-no-brand]')) return;
      var top = el;
      while (top.parentNode && top.parentNode.nodeType === 1 && /^(EM|STRONG|I|B|SPAN)$/.test(top.parentNode.nodeName) && (top.parentNode.textContent || '').trim().toLowerCase() === 'now') top = top.parentNode;
      var prev = top.previousSibling, next = top.nextSibling, c, d;
      if (prev && prev.nodeType === 3 && /candy$/i.test(prev.nodeValue)) { c = prev.nodeValue.slice(-5); prev.nodeValue = prev.nodeValue.slice(0, -5); }
      else if (prev && prev.nodeType === 1 && /^candy$/i.test((prev.textContent || '').trim())) { c = prev.textContent.trim(); prev.parentNode.removeChild(prev); }
      else return;
      var nt = next && next.nodeType === 3 ? next : (next && next.nodeType === 1 ? firstText(next) : null);
      if (!nt || !/^\.ca/i.test(nt.nodeValue)) {
        // put 'candy' back, this is not the wordmark
        top.parentNode.insertBefore(document.createTextNode(c), top); return;
      }
      d = nt.nodeValue.slice(0, 3); nt.nodeValue = nt.nodeValue.slice(3);
      top.parentNode.replaceChild(mk(c, el.textContent.trim(), d, tone(top.parentNode)), top);
    });
  }
  function wrapText(node) {
    var text = node.nodeValue;
    if (!text || text.toLowerCase().indexOf('candynow.ca') === -1) return;
    if (skip(node)) return;
    RE.lastIndex = 0;
    var frag = document.createDocumentFragment(), last = 0, m, hit = false, t = null;
    while ((m = RE.exec(text))) {
      hit = true;
      if (t === null) t = tone(node.parentNode);
      var start = m.index + m[1].length;
      frag.appendChild(document.createTextNode(text.slice(last, start)));
      frag.appendChild(mk(m[2], m[3], m[4], t));
      last = start + m[2].length + m[3].length + m[4].length;
    }
    if (!hit) return;
    frag.appendChild(document.createTextNode(text.slice(last)));
    node.parentNode.replaceChild(frag, node);
  }
  function scan(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 11)) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), list = [], n;
    while ((n = w.nextNode())) list.push(n);
    list.forEach(wrapText);
    if (root.nodeType === 1 || root.nodeType === 11) fixSplit(root);
  }
  var obs = null, queue = [], timer = 0;
  function flush() {
    timer = 0;
    if (obs) obs.disconnect();
    queue.splice(0).forEach(function (el) { if (el.isConnected !== false) { el.nodeType === 3 ? wrapText(el) : scan(el); } });
    if (obs) obs.observe(document.body, { childList: true, subtree: true });
  }
  function start() {
    scan(document.body);
    if (!window.MutationObserver) return;
    obs = new MutationObserver(function (recs) {
      recs.forEach(function (r) { Array.prototype.forEach.call(r.addedNodes, function (nd) { if (!(nd.nodeType === 1 && nd.classList.contains('cn-brand'))) queue.push(nd); }); });
      if (queue.length && !timer) timer = setTimeout(flush, 150);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();
